module.exports = __webpack_public_path__ + "static/media/hotlink_new_logo.446c01c8.png";